/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashfix_Error_Durable_ExpiredInputs */

const en_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durable request expired before completion.`)
};

const zh_hans1_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`异步请求在完成前已过期。`)
};

const pt_br2_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A requisição assíncrona expirou antes de terminar.`)
};

const es_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La solicitud asíncrona expiró antes de completarse.`)
};

const fr_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La requête durable a expiré avant la fin.`)
};

const de_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die persistente Anfrage ist vor dem Abschluss abgelaufen.`)
};

const ru_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок устойчивого запроса истёк до завершения.`)
};

const it_dashfix_error_durable_expired = /** @type {(inputs: Dashfix_Error_Durable_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La richiesta durevole è scaduta prima del completamento.`)
};

/**
* | output |
* | --- |
* | "Durable request expired before completion." |
*
* @param {Dashfix_Error_Durable_ExpiredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_error_durable_expired = /** @type {((inputs?: Dashfix_Error_Durable_ExpiredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Error_Durable_ExpiredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_error_durable_expired(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_error_durable_expired(inputs)
	if (locale === "es") return es_dashfix_error_durable_expired(inputs)
	if (locale === "fr") return fr_dashfix_error_durable_expired(inputs)
	if (locale === "de") return de_dashfix_error_durable_expired(inputs)
	if (locale === "ru") return ru_dashfix_error_durable_expired(inputs)
	if (locale === "it") return it_dashfix_error_durable_expired(inputs)
	return en_dashfix_error_durable_expired(inputs)
});